import BaseScreen from './base-screen.container';

export default BaseScreen;
